import { render, staticRenderFns } from "./CompanySettings.vue?vue&type=template&id=0474ab00&scoped=true"
import script from "./CompanySettings.vue?vue&type=script&lang=ts"
export * from "./CompanySettings.vue?vue&type=script&lang=ts"
import style0 from "./CompanySettings.vue?vue&type=style&index=0&id=0474ab00&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0474ab00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0474ab00')) {
      api.createRecord('0474ab00', component.options)
    } else {
      api.reload('0474ab00', component.options)
    }
    module.hot.accept("./CompanySettings.vue?vue&type=template&id=0474ab00&scoped=true", function () {
      api.rerender('0474ab00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/CompanySettings.vue"
export default component.exports